import { createAdminUser } from '@common/api/account';
import { CreateAdminUserPayload } from '@common/api/account/types';
import { useNotificationsStore } from '@common/store/notifications';
import { RPGUsersQueryKeys } from '@common/types/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type ApiErrorResponse = {
  username?: string[];
  password?: string[];
  first_name?: string[];
  last_name?: string[];
};

export const useAddNewAdminUser = () => {
  const { addNotification } = useNotificationsStore();
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    isSuccess,
    error
  } = useMutation({
    mutationFn: async (payload: CreateAdminUserPayload) => {
      const response = await createAdminUser(payload);
      return response;
    },
    onSuccess: () => {
      addNotification('success', 'User created successfully');
      queryClient.invalidateQueries({ queryKey: [RPGUsersQueryKeys.GET_ADMIN_USER_LIST] });
    }
  });

  return {
    createAdminUser: mutateAsync,
    isLoading,
    isSuccess,
    error: error as AxiosError<ApiErrorResponse> | null
  };
};
